import config from '../../../config';

function initPowerUps (layer) {
  let g = this.g;

  // conditions for a power up collectable to appear
  // bile must be traveling at max speed
  // a power up must not currently be active
  // a cool down must not be currently active

  // console.log({
  //   activePowerUp: g.activePowerUp,
  //   coolDownActive: g.coolDownActive,
  //   bileSpeed: g.bile.speed !== config.BILE_MAX_SPEED
  // });

  let minSpeedAchieved = false;
  if (g.bile && g.bile.speed) {
    minSpeedAchieved = g.bile.speed >= config.BILE_POWER_SPEED;
  }

  if (g.activePowerUp || g.coolDownActive || !minSpeedAchieved || g.isContinue) {
    _.each(layer.groups.tiles, (sprite) => {
      sprite.play('coin-spin');
      sprite.isCoin = true;
    });
  } else {
    // console.warn('!!! collectable power up available !!!');
    if (layer.groups.tiles.length > 1) {
      console.warn('More than collectable power up has been added to the map, you should not get this');
    }
  }
}

export {
  initPowerUps
};
